import React, { useEffect, useState } from "react";
import { Form, Button, Image, Icon, Label } from "semantic-ui-react";
import { useFormik } from "formik";
import {
  initialValuesOne,
  validationSchemaOne,
  categoryOptions,
  subcategoryOptions,
} from "./StepOne.form";
import { SceneFormFile } from "./SceneFormFile";
import { VirtualScenes } from "../../../../api";
import { useAuth } from "../../../../hooks";
import "./SceneForm.scss";
import { TiptapEditor } from "../../../TiptapEditor/TiptapEditor";

const virtualSceneController = new VirtualScenes();

export function StepOne({
  formData,
  updateFormData,
  nextStep,
  prevStep,
  isUpdateMode,
  scene,
}) {
  const { accessToken } = useAuth();
  const [isFileModalOpen, setIsFileModalOpen] = useState(false);
  const [isPublic, setIsPublic] = useState(true);
  const [fileFieldName, setFileFieldName] = useState("");
  const [moduleData, setModuleData] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState({
    bannertop: formData.bannertop || null,
  });

  // Cargar los datos del módulo si estamos en modo de actualización
  // Cargar los datos del módulo si estamos en modo de actualización
  useEffect(() => {
    async function fetchData() {
      if (isUpdateMode && scene?.refId) {
        try {
          const data = await virtualSceneController.getVirtualScenesModeule(
            scene.refId,
            accessToken,
            "module_01",
          );
          setModuleData(data.moduleData); // Suponiendo que 'data' ya contiene los campos correctos
          //console.log("module", data.moduleData);
          //console.log("category", data.moduleData.category);
        } catch (error) {
          console.error("Error fetching module data:", error);
        }
      }
    }
    fetchData();
  }, [isUpdateMode, accessToken, scene?.refId]);

  const formik = useFormik({
    initialValues: isUpdateMode
      ? initialValuesOne(moduleData)
      : initialValuesOne(formData),
    validationSchema: validationSchemaOne(),
    validateOnChange: false,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        const _id =
          isUpdateMode && scene?.refId
            ? scene.refId
            : localStorage.getItem("idScene");

        // Handle tagsInput before updating formData
        if (values.tagsInput) {
          values.ModOneTags = [...values.ModOneTags, values.tagsInput.trim()];
          values.tagsInput = "";
        }
        //compruebo que el local storage este vacio o null para no guardar un idScene que no corresponda
        const modulePath = "module_01";
        console.log("values", values);
        console.log("formData", formData);
        await virtualSceneController.createModuleAdd(
          modulePath,
          accessToken,
          _id,
          values,
        );
        //console.log("response", respone);
      } catch (error) {
        console.error("Error al enviar el formulario:", error);
      }

      updateFormData({ ...values, ...uploadedFiles });
      nextStep();
    },
  });

  useEffect(() => {
    // Este efecto ahora SOLO se encarga de buscar los datos del archivo
    // una vez que 'moduleData' y su propiedad 'bannertop' están disponibles.
    if (moduleData?.bannertop) {
      async function fetchBannertopFile() {
        try {
          const fileData = await virtualSceneController.getFileScene(
            moduleData.bannertop,
          );
          setUploadedFiles((prev) => ({
            ...prev,
            bannertop: fileData,
          }));
        } catch (error) {
          console.error("Error al obtener los datos de bannertop:", error);
        }
      }
      fetchBannertopFile();
    }
    // La dependencia ahora es más específica y segura.
    // Dependemos del ID del bannertop para evitar re-fetches innecesarios.
  }, [moduleData?.bannertop]);

  const handleFileSubmit = (fileData) => {
    const { id } = fileData;

    if (fileFieldName === "bannertop") {
      // For single file fields
      setUploadedFiles((prev) => ({
        ...prev,
        [fileFieldName]: fileData,
      }));
      formik.setFieldValue(fileFieldName, id);
    } else {
      // For multiple files
      setUploadedFiles((prev) => ({
        ...prev,
        [fileFieldName]: [...prev[fileFieldName], fileData],
      }));
      formik.setFieldValue(fileFieldName, [
        ...formik.values[fileFieldName],
        id,
      ]);
    }
  };

  const handleRemoveFile = async (fieldName) => {
    let fileId;
    if (uploadedFiles[fieldName]) {
      fileId = uploadedFiles[fieldName]._id;
      //console.log("fileId", fileId);
      //console.log("fieldName", fieldName);
      //console.log("uploadedFiles", uploadedFiles);
      try {
        await virtualSceneController.deleteImageRepo(accessToken, fileId);
        setUploadedFiles((prev) => ({
          ...prev,
          [fieldName]: null,
        }));
        formik.setFieldValue(fieldName, null);
      } catch (error) {
        console.error("Error al eliminar el archivo:", error);
      }
    }
  };

  return (
    <Form className="virtual-scene-form" onSubmit={formik.handleSubmit}>
      {/* Title */}
      <Form.Input
        label="Título de la escena virtual"
        name="ModOneTitle"
        placeholder="Ingrese el título"
        onChange={formik.handleChange}
        value={formik.values.ModOneTitle}
        error={formik.errors.ModOneTitle}
      />

      {/* Category */}
      <Form.Select
        label="Categoría"
        name="ModOneCategory"
        options={categoryOptions}
        placeholder="Seleccione la categoría"
        multiple
        onChange={(e, { name, value }) => formik.setFieldValue(name, value)}
        value={formik.values.ModOneCategory || []}
        error={formik.errors.ModOneCategory}
      />

      {/* Subcategory */}
      <Form.Select
        label="Subcategoría"
        name="ModOneSubcategory"
        options={subcategoryOptions}
        placeholder="Seleccione las subcategorías"
        multiple
        onChange={(e, { name, value }) => formik.setFieldValue(name, value)}
        value={formik.values.ModOneSubcategory || []}
        error={formik.errors.ModOneSubcategory}
      />

      <div className="tags-container">
        {formik.values.ModOneTags.map((tag, index) => (
          <Label key={index}>
            {tag}
            <Icon
              name="delete"
              style={{ cursor: "pointer", marginLeft: 6 }}
              onClick={() => {
                const newTags = formik.values.ModOneTags.filter(
                  (_, i) => i !== index,
                );
                formik.setFieldValue("ModOneTags", newTags);
              }}
            />
          </Label>
        ))}
      </div>

      {/* Tags */}
      <Form.Input
        label="Etiquetas"
        name="tagsInput"
        placeholder="Ingrese una etiqueta"
        value={formik.values.tagsInput || ""}
        onChange={formik.handleChange}
        error={formik.errors.ModOneTags}
      />

      <div className="button-container">
        <Button
          type="button"
          onClick={() => {
            if (formik.values.tagsInput) {
              formik.setFieldValue("ModOneTags", [
                ...formik.values.ModOneTags,
                formik.values.tagsInput.trim(),
              ]);
              formik.setFieldValue("tagsInput", "");
            }
          }}
        >
          Añadir Etiqueta
        </Button>
      </div>
      {/* Descripción */}
      <label className="field-label">Descripción</label>
      <TiptapEditor
        content={formik.values.ModOneDescription}
        onChange={(newContent) =>
          formik.setFieldValue("ModOneDescription", newContent)
        }
      />
      {/* URLsala */}
      <Form.Input
        label="URL de la sala"
        name="ModOneUrlsala"
        placeholder="Ingrese la URL"
        onChange={formik.handleChange}
        value={formik.values.ModOneUrlsala}
        error={formik.errors.ModOneUrlsala}
      />

      {/* File Upload for Bannertop */}
      <div className="upload-field">
        <label>Imagen de Portada</label>
        <Button
          type="button"
          onClick={() => {
            setIsPublic(true);
            setFileFieldName("bannertop");
            setIsFileModalOpen(true);
          }}
        >
          Subir imagen
        </Button>
        {uploadedFiles.bannertop && (
          <div className="image-preview">
            <Image src={uploadedFiles.bannertop.url} size="small" centered />
            <Icon name="close" onClick={() => handleRemoveFile("bannertop")} />
          </div>
        )}
        {formik.errors.bannertop && (
          <div className="error-message">{formik.errors.bannertop}</div>
        )}
      </div>

      {/* Modal for File Upload */}
      <SceneFormFile
        isOpen={isFileModalOpen}
        onClose={() => setIsFileModalOpen(false)}
        onSubmit={handleFileSubmit}
        isPublic={isPublic}
        idScene={formik.values.idScene}
      />

      <div className="formgroup">
        <Form.Group>
          <Button
            type="button"
            onClick={prevStep}
            color="orange"
            style={{ width: "33.3333%" }}
          >
            Anterior
          </Button>
          <Button
            type="submit"
            primary
            style={{
              width: isUpdateMode ? "33.3333%" : "66.6666%",
              marginLeft: isUpdateMode ? "auto" : "33.3333%",
            }}
            loading={formik.isSubmitting}
          >
            Subir
          </Button>
          {isUpdateMode && (
            <Button
              type="button"
              onClick={nextStep}
              color="green"
              style={{ width: "33.3333%" }}
            >
              Siguiente
            </Button>
          )}
        </Form.Group>
      </div>
    </Form>
  );
}
